import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import WellnessService from "services/WellnessService";
import Loader from "components/Loader";
import TriviaListItem from 'components/TriviaGames/TriviaListItem';

function SingleTrivia() {
	const { triviaId } = useParams();
	const { teamId } = useTeamActionContext();
	const [trivia, setTrivia] = useState([]);
	const [loaded, setLoaded] = useState(false);
	const [activeTrivia, setActiveTrivia] = useState(0);
	const [reload, setReload] = useState(false);


	useEffect(() => {
		setLoaded(false);
		WellnessService.getAllTriviaList(teamId).then((res) => {
			let result = res.data.find(triv => triv.id === Number(triviaId));
			setTrivia(result || []);
			setActiveTrivia(result?.id || 0);
			setLoaded(true);
		});
	}, [teamId, reload, triviaId]);


	return (
		<div>
			{!loaded && (
				<div className="d-flex justify-content-center">
					<Loader />
				</div>
			)}

			{loaded && trivia.length === 0 && (
				<div className="d-flex justify-content-center">
					No trivia created yet, click on Add New to create your very first
					trivia
				</div>
			)}

			{loaded && Object.keys(trivia).length > 0 && (
				<div class="list-group">
					<TriviaListItem
						data={trivia}
						setActiveTrivia={setActiveTrivia}
						activeTrivia={activeTrivia}
						setReload={() => setReload(!reload)}
					/>
				</div>
			)}
		</div>
	)
}

export default SingleTrivia